import "../../assets/css/home.css";
import { useState, useEffect, useRef } from "react";
import { Login } from "../../components/form/Login";
import { Register } from "../../components/form/Register";
import { ForgotPassword } from "../../components/form/ForgotPassword";
import { SocialBar } from "../../components/socialmedia/SocialBar";



function Home() {
  const [canShowPage, setCanShowPage] = useState(false);
  const listLinkSocialMedia = useRef({
    socialmedia: { instagram: "", youtube: "", whatsapp: "" },
  });

  const [sessionForm, setSessionForm] = useState("login");

  useEffect(() => {
    fetch("/config.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load config");
        return res.json();
      })
      .then((data) => {
        listLinkSocialMedia.current = data;
        setCanShowPage(true);
      });
  }, []);

  return (
    <>
      {canShowPage === true ? (
        <div className="d-flex" style={{ minHeight: "100vh" }}>
          
          <div id="home-container-form">

          <div className="home-container-mobile">
            <SocialBar
            instagramUrl={listLinkSocialMedia.current.socialmedia.instagram}
            youtubeUrl={listLinkSocialMedia.current.socialmedia.youtube}
            whatsappUrl={listLinkSocialMedia.current.socialmedia.whatsapp}
            />
            </div>

            {sessionForm === "register" ? (
              <Register setSessionForm={setSessionForm} />
            ) : sessionForm === "forgot_password" ? (
              <ForgotPassword setSessionForm={setSessionForm} />
            ) : (
              <Login setSessionForm={setSessionForm} />
            )}

            

          </div>
          
          <div id="home-container-welcome" className="w-100 bg-dark">
            <SocialBar
            instagramUrl={listLinkSocialMedia.current.socialmedia.instagram}
            youtubeUrl={listLinkSocialMedia.current.socialmedia.youtube}
            whatsappUrl={listLinkSocialMedia.current.socialmedia.whatsapp}
            />
          </div>
          
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Home;
